/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export const POSTER_IMAGE_DIMENSION = '662x372';
/* Poster Image Name can be anyof the following: atmospheric_, showcaseBanner_ */
export const POSTER_IMAGE_NAME = 'showcaseBanner_';

export const PROVIDER_IMAGE_DIMENSION = '49x49';

export const PROVIDER_IMAGE_NAME = 'partnerSourceLogo_';
